import { z } from "zod";

export const getRoleMemberSchema = z.object({
	roleId: z.uuid(),
	userId: z.string().nonempty(),
});

export type GetRoleMemberSchema = z.infer<typeof getRoleMemberSchema>;
